import { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import PropTypes from "prop-types";
import FaqHomeCategory from "app/pages/Faq/FaqHome/FaqHomeCategories/FaqHomeCategory";
import "./FaqCategoriesSlider.scss";

const FaqCategoriesSlider = ({ categories = [] }) => {
	const swiperRef = useRef(null);
	const [isEnd, setIsEnd] = useState(false);
	const [isBeginning, setIsBeginning] = useState(true);

	const showArrows = categories.length > 4;

	return (
		<div className="faq-categories-slider">
			<Swiper
				onSwiper={swiper => {
					swiperRef.current = swiper;
				}}
				slidesPerView={4}
				centerInsufficientSlides={true}
				spaceBetween={21}
				onSlideChange={swiper => {
					setIsEnd(swiper.isEnd);
					setIsBeginning(swiper.isBeginning);
				}}
			>
				{categories.map(category => (
					<SwiperSlide key={category.id}>
						<FaqHomeCategory
							categoryName={category.name}
							categoryId={category.id}
							subCategories={category.subCategories}
							categoryPicture={category.image}
						/>
					</SwiperSlide>
				))}
			</Swiper>
			<div className="faq-categories-slider__button faq-categories-slider__button--next">
				{showArrows && !isEnd && (
					<i
						className="icon icon--round-blue-next"
						onClick={() => swiperRef.current?.slideNext()}
					/>
				)}
			</div>
			<div className="faq-categories-slider__button faq-categories-slider__button--previous">
				{showArrows && !isBeginning && (
					<i
						className="icon icon--round-blue-previous"
						onClick={() => swiperRef.current?.slidePrev()}
					/>
				)}
			</div>
		</div>
	);
};

FaqCategoriesSlider.propTypes = {
	categories: PropTypes.array,
};

export default FaqCategoriesSlider;
